import React, { Component } from "react";
import './Face.css';
// import './Face_v2.css';
import Cookies from "js-cookie";
import * as actions from '../Actions';
import { fetchInitialData2 } from "../../fetchData";
import Right from '../../right/Right';
import Service from '../../service/Service';
import withContext from "../../../withContext";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import UploadFrame from '../common/UploadFrame';
import UploadImgOverlay from '../common/UploadImgOverlay';
import ShareMileOverlay from '../common/ShareMileOverlay';

const service = new Service();

class UploadFaces extends Component {
    constructor(props) {
        super(props);
        let initialData = [];
        let ContestData = [];
        let ProductData = [];
        let authData = '';

        let childList = global.userAry['childData']?.UserChildList || [];

        if (__isBrowser__ && window.__initialData__ && window.__initialData__['initialData']) {
            initialData = window.__initialData__['initialData'];
            console.log("Initial Data in UploadFaces:", initialData);
            authData = window.__initialData__["authData"];  
            //console.log("Auth Data in UploadFaces:", authData);
            delete window.__initialData__;
        } else {
            if (props.staticContext && props.staticContext.initialData && props.staticContext.initialData['initialData']) {
                initialData = props.staticContext.initialData['initialData'];
            }
        }
        if (initialData) {
            if (initialData['data1'] && initialData['data1']) {
                // console.log("contest data", initialData['data1']?.['result']);
                ContestData = initialData['data1']?.['result'];
            }
            if (initialData['data2'] && initialData['data2']['result']) {
                ProductData = initialData['data2'];
            }
        }

        this.state = {
            initialData: initialData,
            ContestData: ContestData,
            ProductData: ProductData,
            childListData: childList,
            childName:Cookies.get('ChildName'),
            childId:Cookies.get('ChildId'),
            frameDate:Cookies.get('faceDate'),
            isFaceUploaded:false,
            contestId: '',
            hashTag:'',
            insertIds: [],
            tagProd: [],
            tagKids: [],
            insertProdIds: [],
            selectedfile: '',
            imagePreviewUrl: '',
            croppedImageUrl: '',
            onErrorImg:'',
            Base64: '',
            cropx: '',
            cropy: '',
            cropwidth: '',
            cropheight: '',
            cropedImagePath: '',
            selStickersAry: [],
            gender: '',
            userPhoto: '',
            frameId: Cookies.get('faceFrameId'),
            fcAuth: global?.ftk || "",
            src: null,
            isMemorySelected: false,
            IsExpected: false,
            crop: {
                x: 0,
                y: 0,
                width: 200,
                height: 200,
            },

        };

    }

    static initialAction(reqUrl, ftk, authData, uId, childData) {
        var header = {
            'Content-Type': 'application/json',
            'ftk': ftk,
            'uid': uId,
            'access-token': authData['access-token'],
            'user-agent': global.userAgent,
            'isdesktop': global.isdesktop
        }
        let obj1 = {
            url: global.api_url + "contest/getactivecontests",
            body: JSON.stringify({
                "type": "communitypostmemory"
            })
        };
        let obj2 = {
            url: global.api_url + "getproductfromhistory",
            // url: "http://preprodparenting.fcappservices.in/getproductfromhistory", // For staging env
            body: JSON.stringify({
                'pageNo': 1,
                'pageSize': 15
            })
        };
        return fetchInitialData2(obj1, obj2, JSON.stringify(header));
    }


    componentDidMount() {

        document.addEventListener("click", this.domClick);
        window.addEventListener("beforeunload", this.handleBeforeUnload);
        const imgs = document.querySelectorAll("img.loadingImg");

        imgs.forEach(img => {
            const realSrc = img.getAttribute("data-src");

            if (realSrc && realSrc !== "undefined" && realSrc !== "") {
                const temp = new Image();
                temp.onload = () => {
                    img.src = realSrc;
                };
                temp.src = realSrc;
            }
        });

        // console.log('-------------global.userAry------------------',global.userAry?.['childData']?.UserMaster);
        // console.log('fcAuth in uploadfaces.js:',this.state.fcAuth);
        // service.lazyLoadImages();
        // console.log('------------childlistdata in uploadfaces.js------------------',this.state.childListData);
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.domClick);
        window.removeEventListener("beforeunload", this.handleBeforeUnload);
    }

    domClick(event) {
        console.log("event Dom========>",event.target)
        if (event.target.classList.contains('options_overlay')) {
            document.getElementsByClassName('options_overlay')[0].style.display = 'none';
            document.getElementsByTagName('body')[0].style.overflow = 'auto';
        }
         
    }

    handleBeforeUnload = (e) => {
        if (!this.state.isFaceUploaded) {   // or any condition you want
            e.preventDefault();
            e.returnValue = "";
        }
    };

    onChange(e) {
        console.log('--------------onchange called------------------');

        const file = e.target.files[0];
        const allowedTypes = ['image/jpeg', 'image/png'];
        const allowedExt = /\.(jpg|jpeg|png)$/i;

        if (!allowedTypes.includes(file.type) || !allowedExt.test(file.name)) {
            e.target.value = null;
            document.getElementsByClassName('file_upload_err')[0].innerHTML =
                "Only JPEG, JPG and PNG files allowed";
            document.getElementsByClassName('file_upload_err')[0].style.display = "block";
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible"; 
            return false;
        }
        
        if (navigator.onLine) {
            var fileObj = document.getElementById("face_upload").files[0];
            console.log(fileObj);
            if (fileObj.type.includes('image')) {
                console.log("image");
                if (fileObj.type && (fileObj.type.toLowerCase() == "image/jpg" || fileObj.type.toLowerCase() == "image/jpeg" || fileObj.type.toLowerCase() == "image/png") && fileObj.size < 8388608) {
                    this.setState({ isMemorySelected: true });
                    document.getElementsByClassName('file_upload_err')[0].style.display = "none";
                    document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
                    if (this.isJcropFilesLoaded) {
                        actions.afterJcropFilesLoaded(fileObj);
                    } else {
                        var _this=this;
                        service.loadJcropFiles(_this).then(function () {
                            _this.isJcropFilesLoaded = true;
                            actions.afterJcropFilesLoaded(fileObj);
                        }).catch(function () {
                            _this.setState({ isMemorySelected: false });
                            document.getElementById("face_upload").value = null;
                            return false;
                        })
                    }
                } else {
                    document.getElementById("face_upload").value = null;
                    document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                    document.getElementsByClassName('file_upload_err')[0].style.visibility = "unset",
                    document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                    return false;
                }
            } else {
                document.getElementById("face_upload").value = null;
                document.getElementsByClassName('file_upload_err')[0].style.display = "block";
                document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Select Valid Photo";
                
                return false;
            }
        } else {
            document.getElementById("face_upload").value = null;
            service.showAlert("Please Check Internet Connection!!!");
        }
    }

    UploadPhoto() {
        console.log('--------------1111111111111111');
       

        // e.preventDefault();
        var submit=true;

        if (!this.state.contestId && this.state.contestId == undefined) {
            this.state.contestId = 0;
        }
        for (var i = 0; i < this.state.childListData.length; i++) {
            if (this.state.childListData) {
                if (this.state.childListData.length >= 1) {
                    if (this.state.childListData[i]['ChildId']==document.querySelector('.slide-tag-active').getAttribute('data-id')) {
                        if(this.state.childListData[i]['Gender']=='Boy') {
                            this.state.gender = 0;
                        } else {
                            this.state.gender = 1;
                        }
                        this.state.tagKids = [{
                            "childId": this.state.childListData[i]['ChildId'],
                            "childName": this.state.childListData[i]['ChildName'],
                            "dob": this.state.childListData[i]['DOB'],
                            "gender": this.state.gender,
                            "childPic": this.state.childListData[i]['childPhoto']
                        }];
                    }
                }
            }
        }
        if (document.querySelector(".checkAll").classList.contains("isChecked")) {
            this.state.userPhoto = document.querySelector("#main_frame").src;
        } else {
            this.state.userPhoto = global.userAry['userPhoto'];
        }
        if (this.state.ProductData != '-1') {
            var comboval = 0;
            for (var i = 0; i < this.state.ProductData.length; i++) {
                if (this.state.ProductData['productId'] == this.state.insertProdIds[i]) {
                    comboval = this.state.ProductData['isCombo'];
                    this.state.tagProd = {
                        "productId": this.state.ProductData['productId'],
                        "isActive": this.state.ProductData['isActive'],
                        "productName": this.state.ProductData['productName'],
                        "isInStock": this.state.ProductData['isInStock'],
                        "catId": this.state.ProductData['catId'],
                        "subCatId": this.state.ProductData['subCatId'],
                        "brandId": this.state.ProductData['brandId'],
                        "isCombo": comboval
                    }
                }

            }
        }
        if (document.querySelector("#main_frame").src == Cookies.get("faceFrameUrl")){
            return document.getElementsByClassName('file_upload_err')[0].style.display = "inline-block",
                document.getElementsByClassName('file_upload_err')[0].style.visibility = "visible",
                document.getElementsByClassName('file_upload_err')[0].innerHTML = "Please Upload Face Memory",
                submit = false,
                !1;
        }else{
            document.getElementsByClassName('file_upload_err')[0].style.display = "none",
            document.getElementsByClassName('file_upload_err')[0].style.visibility = "hidden",
            document.getElementsByClassName('file_upload_err')[0].innerHTML = "";
        }

        if (this.state.childListData.length > 0) {
            if (document.querySelector('.slide-tag-active').getAttribute('data-id') == "") {
                alert('You need to tag atleast one child in your post');
                document.querySelector('#tagIds').focus();
                submit = false;
                return false
            }
        }
        if (this.state.contestId.length > 0) {
            this.state.contestId = this.state.contestId
        } else {
            this.state.contestId = ""
        }
        if(submit){
            console.log('--------------22222222222222');
            this.uploadFaceMemory();
        }
    }

    CancleButton =() => {

        if (!window.confirm("Your changes would be discarded, do you want to continue?")) {
            return;
        }
        //  this.resetCropAndImage();
       
        const defaultFrame = Cookies.get("faceFrameUrl");

        const mainFrame = document.getElementById("main_frame");
        if (mainFrame) {
            mainFrame.src = defaultFrame;
        }

        // Clear file input
        const fileInput = document.getElementById("face_upload");
        if (fileInput) {
            fileInput.value = "";
        }

        
        document.querySelector('.add_photo_lbl').style.display = "block";
        document.querySelector('.choose_photo_btns').style.display = "block";
        document.querySelector('.upload_photo_btns').style.display = "none";
        this.setState({ isMemorySelected: false });
        console.log('--------------cancle button called------------------');

        actions.clearMemoryImageData(this, "FB", false);
        
    }


    uploadFaceMemory() {
        service.showLoader();
        // console.log("this.state.gender========>", this.state.gender);
        let childArr = this.state.childListData;
        let transformedChildArr = childArr.map(child => ({
            childId: child.ChildId,
            childName: child.ChildName,
            dob: child.DOB,
            gender: child.Gender,
            childPic: child.childPhoto
        }));

        let setprofilePick = document.querySelector(".checkAll").classList.contains("isChecked");

        var postData = {
            "postType": "0",
            "imageWidth": "450",
            "imageHeight": "450",
            "myself": document.querySelector("#setmyselfval").value,
            "setAsProfilePic": String(document.querySelector(".checkAll").classList.contains("isChecked")),
            "userPic": this.state.userPhoto,
            "userName": global.userAry['userName'],
            "userId": global.userAry['userId'],
            "userGender": global.userAry['Sex'] == "male" ? 1 : 0,
            "childArr": transformedChildArr,
            "image": document.querySelector("#main_frame").src,
            "desc": document.querySelector('#photodesc').value,
            "tagKids": this.state.tagKids,
            "tagProd": this.state.tagProd,
            "contestId": this.state.contestId || 0,
            "faceDate":this.state.frameDate,
            "frameId": this.state.frameId,
        }

        var url = global.api_ci_url + "api/fetchfromCI/uploadmemory"; //uploadmemory

        service.postServiceCall(url, postData).then((json) => {
            console.log("API Responce in uploadFaceMemory:-----------111111", json);
            if (json['msg'] == 1 && this.state.cropedImagePath != "") {
                console.log("API Responce in success image");
                // Cookies.set("faceFrameUrl", '', 1);
                // this.state.isFaceUploaded=true;
                this.setState({ isFaceUploaded: true }, () => {
                    // optional: remove listener immediately
                    window.removeEventListener("beforeunload", this.handleBeforeUnload);
                });
                document.getElementById("shareMileImg").src = this.state.cropedImagePath;
                document.getElementsByClassName("shareMile-overlay")[0].style.display = "block";
                if (window.innerWidth < 767) {
                    document.querySelector('.shareImg-container').style.left = (((window.innerWidth * 0.85) - 208) / 2) + "px";
                }
                var ischecked = document.getElementById('setpic').classList.contains("isChecked");
            }
            service.hideLoader();
        }).catch((error) => {
            console.error("error", error);
            service.hideLoader();
        });


        if(setprofilePick){

            let userMaster_data = global.userAry?.['childData']?.UserMaster || {};
            console.log("userMaster in uploadFaceMemory:-----------", userMaster_data);
            const postData = 
            {
                "objUserMaster": {
                    "EmailAddress": this.state.fcAuth || "",
                    "firstname": userMaster_data.firstname || "",
                    "middlename": userMaster_data.middlename || "",
                    "lastname": userMaster_data.lastname || "",
                    "pmno": String(userMaster_data.mobileno || ""),
                    "mobileno": String(userMaster_data.mobileno || ""),
                    "DateOfBirth": userMaster_data.DateOfBirth || "",
                    "Sex": userMaster_data.Sex || "Female",
                    "MaritalStatus": userMaster_data.MaritalStatus || "Married",
                    "AD": userMaster_data.AD || "",
                    "WalletAmount": userMaster_data.WalletAmount || 0,
                    "userPhoto":  this.state.userPhoto || "",
                    "IsTryingToConceive": userMaster_data.IsTryingToConceive || "0"
                }
            };
            
            const url_info = global.api_ci_url + "Profile/updateUserDetails";
            service.postServiceCall(url_info, postData)
                .then((json) => {
                    console.log("API Responce in uploadFaceMemory for UserMaster:-----------", json);
                })
                .catch((error) => {
                    console.error("Error fetching:", error);
                });
            
        }
    }

     shareMileCloseButton() {
        document.querySelector('.shareMile-overlay').style.display = "none";
        window.location.href = service.getRedirectUrl('/memories/');
    }


    render() {

        const {
            childName = "",
            frameDate = "",
            childinfo = [],
            selectedChild = "",
            contestArr = { result: [] },
            contestId = "",
            hashtag = ""
        } = this.props;  // adjust based on where you receive data

        return (
            <>
                <main className="main-container Face">
                    <Helmet
                        title="Capture Your Baby Moments Everyday - FirstCry Parenting"
                        meta={[
                            { "name": "description", "content": "Preserving baby memories is one of the best ways to save the precious moments of your baby so that you can’t miss out those lovely & funny moments of your child’s first year. With capture baby moments tool this is made easy. Picture today." }, { "name": "atdlayout", "content": "tools_sp" }
                        ]}
                    />
                    <div className="title">
                        <div className="breadcrumb R11_9e">
                            <span><a href={service.getRedirectUrl("/")} className="R11_9e">Home</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span><a href={service.getRedirectUrl("/tools")} className="R11_9e">Tools</a></span>
                            <span className="R11_9e breadcrum_icon" data-icon-font="l"></span>
                            <span>Baby Moments </span>
                        </div>
                        <h1 className="B24_00" id="skipToH1" tabIndex={0}>Capture "{String(this.state.childName).charAt(0).toUpperCase() + String(this.state.childName).slice(1)}" Memories</h1>
                    </div>
                    <div className="sub-container left">
                        <div className="data-container left">
                            <div className="face_container upload_faces">
                                {/* <input type="hidden" name="tagIds" id="tagIds" value="<?=$childinfo[0]->childId;?>">
                                    <input type="hidden" name="childlen" id="childlen" value="0">
                                <input type="hidden" name="contestid" id="contestid" value="<?php echo $contestId;?>"> */}
                                <input type="hidden" name="tagProdIds" id="tagProdIds" value="" />
                                <input type="hidden" id="setmyselfval" name="setmyselfval" value="0" />
                                <div className="photo_wrapper">
                                    <div className="photo_frame">
                                        <img id="main_frame" src={Cookies.get("faceFrameUrl")} alt={Cookies.get("faceFrameUrl")} title={Cookies.get("faceFrameUrl")} />
                                        <label className="add_photo_lbl" htmlFor="face_upload" >
                                            <span className="R28_9e add_photo_uf">
                                                <span data-icon-font="x" className="icon"></span>
                                                    Add Photo
                                                </span>
                                        </label>
                                        <input type="file" name="face_upload" id="face_upload" accept="image/jpeg,image/png,image/jpg" className="face_upload" onChange={(e) => this.onChange(e)} style={{ 'display': 'none' }} />
                                        <span className="M30_white face_date_container_uf">
                                            {this.state.frameDate}
                                        </span>
                                    </div>
                                    <div className="file_upload_err"></div>
                                </div>
                                {/* <div id="test_append"></div> */}
                                <div className="content_wrapper">
                                  
                                <UploadFrame eleRef={this} ContestData={this.state.ContestData} ProductData={this.state.ProductData.result} Msg={""} tool={"FB"}/>
                                </div>
                            </div>
                        </div>
                    </div>
                  
                    <UploadImgOverlay eleRef={this} tool={"FB"}/>
                    {/* <!--shareMile popup starts-->  */}
                    <ShareMileOverlay eleRef={this} tool={"FB"}/> 
                    {/* <!--shareMile popup ends-->   */}
                    <Right url={this.props.location.pathname} />
                </main>
                
            </>
        );
    }

}


export default withContext(UploadFaces);